// https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/
export default {
  inserted(el, binding) {
    // //////////////////////////////////////////////////
    function loadIamge() {
      if (el.dataset.src || el.dataset.defaultSrc) {
        const img = new Image()
        img.src = el.dataset.src || el.dataset.defaultSrc
        img.onload = function () {
          if (this.width > this.height) {
            el.className = 'landscape'
          }
          el.src = img.src
          setTimeout(() => {
            el.style.opacity = 1
          }, 60)
        }
        img.onerror = (err) => {
          console.error('Image load error', err)
          if (el.dataset.defaultSrc) {
            // el.src = '/img/img-default/img-playlist-default-l.png'
            el.src = el.dataset.defaultSrc
            setTimeout(() => {
              el.style.opacity = 1
            }, 60)
          }
        }
      }
    }
    // //////////////////////////////////////////////////
    function checking() {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight
      const windowPageYOffset = window.pageYOffset
      const bundle = el.getBoundingClientRect()
      if (windowHeight + windowPageYOffset > bundle.top) {
        window.removeEventListener('scroll', checking)
        window.removeEventListener('resize', checking)
        window.removeEventListener('orientationchange', checking)
        loadIamge()
      } else {
        return false // pass
      }
    }
    // //////////////////////////////////////////////////
    if (el.dataset.hide) {
      el.style.opacity = 0
    }
    el.style.transition = 'opacity .2s ease-in'
    window.addEventListener('scroll', checking)
    window.addEventListener('resize', checking)
    window.addEventListener('orientationchange', checking)
    checking()
  },
  bind(el, binding) {
  },
  update(el, binding) {
  }
}
